import { MutableMapStore } from '@deqo/foundation';
import React from 'react';
import styled from 'styled-components';
import { useObserver, waitFor } from '../../../CodesThatsGottaGoSomewhereElse';
import { Check } from '../../../ui/Check';
import { Flexer, Spacer, Title } from '../../dashboard/elements/LayoutElements';
import { AlertManager } from '../../packages/alerts/AlertManager';
import { useProgress } from './ProgressContext';
import { TutorialAlert } from './TutorialAlert';

const StepInfo = styled.div`
    font-size: 1rem;
    color: #b5b5b5;
    margin-top: -1rem;
    margin-bottom: 0.5rem;
`;

export interface TutorialGoal {
    id: string;
    label: string;
}

export class TutorialGoalResults extends MutableMapStore<string, boolean> {

    constructor(private goals: TutorialGoal[]) {
        super(new Map(goals.map(x => [x.id, false])));
    }

    public done() {
        for (const v of this.getState().values()) {
            if (v === false) return false;
        }
        return true;
    }
}

export const TutorialGoal = (id: string, label: string) => ({ id, label });

export const createTutorialGoals = (alerts: AlertManager, goals: TutorialGoal[], stepInfo: [number, number]) => {
    const results = new TutorialGoalResults(goals);
    const handle = alerts.invoke({
        type: 'dialog',
        body: () => <TutorialGoalResultsView {...{ goals, results, stepInfo }} />,
        delay: 0,
        modal: true,
    });
    const mutate = (id: string, complete = true) => {
        results.mutate(x => void (x.set(id, complete)));
        if (results.done()) {
            waitFor(500).then(() => handle.close());
        }
    };
    return mutate;
};

const TutorialGoalResultsView = React.memo<{ goals: TutorialGoal[], results: TutorialGoalResults, stepInfo: [number, number] }>(({ goals, results, stepInfo }) => {
    useObserver(results);

    const { progress, setProgress } = useProgress();
    setProgress(((stepInfo[0] - 1) / stepInfo[1]) * 100);

    return <TutorialAlert>
        <StepInfo>Step {stepInfo[0]}/{stepInfo[1]}</StepInfo>
        <Title>Objectives</Title>
        {goals.map(x =>
            <Flexer key={x.id} flex="row" align="center" padding=".5 0">
                <Check value={results.get(x.id)} />
                <Spacer mode="x" f={1} />
                {x.label}
            </Flexer>
        )}
    </TutorialAlert>;
});
